export const SET_LANG = 'SET_LANG'
export const SET_LANG_LIST = 'SET_LANG_LIST'
export const SET_INIT_LANG = 'SET_INIT_LANG'
export const SET_LOADINGSHOW = 'SET_LOADINGSHOW'